import api from "./api";

export const getProfiles = async (params: {[key: string]: string}) => {

  const {pageSize, pageNumber, title, query,status,minValue,maxValue} = params
  const queryParams = new URLSearchParams();

  if (pageNumber) queryParams.append("pageNumber", pageNumber.toString());
  if (pageSize) queryParams.append("pageSize", pageSize.toString());

  if (query) queryParams.append("query", query);
  if (title) queryParams.append("title", title);
  if (status) queryParams.append("status", status);
  if (minValue) queryParams.append("minValue", minValue);
  if (maxValue) queryParams.append("maxValue", maxValue);

  const response = await api.get(
    `/Resource/GetAllResourceSummary/?${queryParams.toString()}`
  );
  return response.data;
};

export const getProfileDetails = async (id: any) => {
  const list = await api.get(`/Resource/SearchResource/?publicUrl=${id}`);
  return list.data;
};

export const getSuggestedProfiles = async (id: any) => {
  const response = await api.get(`/Resource/SuggestedProfiles/?id=${id}`);
  return response.data;
};

export const getCityList = async function name(countryId: any) {
  const response = await api.get(
    `/SystemLocation/GetCityByCountryId/?id=${countryId}`
  );
  return response.data;
};

export const addProfiles = async (profile: any) => {
  const response = await api.post("/Resource/AddResourceSummary", profile);
  return response.data;
};

export const verifyDisplayName = async (displayName: string) => {
  const response = await api.post("/Resource/VerifyDisplayName", {
    displayName: displayName,
  });
  return response;
};

export const updateResourceStatus = async (id: number, status: string) => {
  const response = await api.put("/Resource/UpdateResourceStatus", {
    id,
    status,
  });
  return response;
};

export const updateResource = async (finalPayload: FormData) => {
  const response = await api.put("/Resource/UpdateResource", finalPayload, {
    headers: {
      "Content-Type": "multipart/form-data", // Required for FormData
    },
  });
  return response;
};

export const getResourceTitles = async () => {
  const response = await api.get("/Resource/GetAllResourceTitle")
  return response.data
}

export const UserDetail = async (email: string) =>{
  const response = await api.post("/Auth/UserDetail", {email})
  return response
}